// extracted by mini-css-extract-plugin
module.exports = {"root":"PendingPaymentAlert_root__3xAlq","buttons":"PendingPaymentAlert_buttons__1dUlD"};